import { VideoRecordingButton } from './VideoRecordingButton';

export default VideoRecordingButton;